import { render, staticRenderFns } from "./menu-report.vue?vue&type=template&id=46bb0458&"
import script from "./menu-report.vue?vue&type=script&lang=ts&"
export * from "./menu-report.vue?vue&type=script&lang=ts&"
import style0 from "./menu-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports